import { Sector } from '@/domain/impact/impact.entity';
import { Category } from '@/domain/impact-co2/entities/question.entity';
import { translate } from '@/ui/i18n';

export class FormatColumnValue {
  static category(category: string): string {
    const categoryCasted = category as Category;
    return translate(`ImpactQuestion.${categoryCasted}.question-title`);
  }

  static sector(sector: string): string {
    const sectorCasted = sector as Sector;
    return sectorCasted ? translate(`Sector.${sectorCasted}`) : '';
  }

  static label(values: unknown): string {
    // @ts-ignore
    if (values.label) {
      // @ts-ignore
      return values.label;
    }
    return '';
  }

  static tags(values: unknown): string {
    // @ts-ignore
    if (values.tags) {
      // @ts-ignore
      return values.tags.map((tag) => tag.name).join(', ');
    }
    return '';
  }

  static external(isExternal: boolean): string {
    if (isExternal) {
      return 'X';
    }
    return '';
  }

  /**
   * Search for a translation for value like accommodationTypeValues.HOTEL = Hôtel...
   * if value is not a string, return the value
   */
  static value(category: string, name: string, value: unknown): string {
    if (value === undefined || value === null || typeof value !== 'string') {
      return value as string;
    }
    const defaultValue = value;
    const translateKey = buildValueTranslateKey(category, name, value);
    const out = translate(translateKey, defaultValue);
    return out;
  }
}

function buildValueTranslateKey(category: string, name: string, value: string) {
  if (category === 'ACCOMMODATION_PUBLIC' && name === 'accommodationType') {
    return `ImpactQuestion.${'ACCOMMODATION' as Category}.${name}Values.${value}`;
  }
  if (category === 'MOBILITY_PUBLIC' && name === 'transportationMode') {
    return `ImpactQuestion.${'MOBILITY' as Category}.${name}Values.${value}`;
  }
  return `ImpactQuestion.${category}.${name}Values.${value}`;
}
